<template>
  <div class="profile-page">
    <h2>
      <a
          style="float: left"
          @click="goBack()"><el-icon name="back" />
      </a>
      My Profile
    </h2>
    <el-row
        :gutter="50"
        class="profile-row">
      <el-col :span="8">
        <div class="profile-label">
          Email
        </div>
      </el-col>
      <el-col :span="16">
        <el-input
            v-model="current_user.email"
            :disabled="true"
            suffix-icon="el-icon-message"
            readonly />
      </el-col>
    </el-row>
    <el-row
        :gutter="50"
        class="profile-row">
      <el-col :span="8">
        <div class="profile-label">
          Full Name
        </div>
      </el-col>
      <el-col :span="16">
        <el-input
            v-model="fullName"
            :disabled="true"
            suffix-icon="el-icon-document"
            readonly />
      </el-col>
    </el-row>
    <el-row
        :gutter="50"
        class="profile-row">
      <el-col :span="8">
        <div class="profile-label">
          Role
        </div>
      </el-col>
      <el-col :span="16">
        <el-select
            v-model="current_user.role"
            placeholder="Select Role"
            @change="updateUser">
          <el-option
              v-for="role in roleList"
              :key="role"
              :value="role" />
        </el-select>
      </el-col>
    </el-row>

    <TimeZoneAndLanguageSelectorRow v-if="hasNewLeftNavEnabled" />
    <el-row
        v-else
        :gutter="50"
        class="profile-row">
      <el-col :span="8">
        <div class="profile-label">
          Timezone
        </div>
      </el-col>
      <el-col :span="16">
        <el-input
            v-model="current_user.timezone"
            :disabled="true"
            suffix-icon="el-icon-location"
            readonly />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { cloneDeep, get } from "lodash";
import { createNamespacedHelpers as h } from "vuex";
const { mapGetters: uiGetters, mapActions: uiActions } = h("ui");
const { mapActions: authActions, mapGetters: authGetters } = h("auth");
import TimeZoneAndLanguageSelectorRow from "./Core/TimeZoneAndLanguageSelectorRow";

export default {
  name: "UserProfile",
  components: { TimeZoneAndLanguageSelectorRow },
  data() {
    return {
      roles: [],
      newRole: "",
      current_user: {},
    };
  },
  computed: {
    ...uiGetters(["currentTimezone"]),
    ...authGetters(["user"]),
    timeZone() {
      return this.currentTimezone || this.current_user.timezone;
    },
    fullName() {
      return `${this.current_user.first_name} ${this.current_user.last_name}`;
    },
    roleList() {
      let roles = [
        "user",
        "user_plus",
        "non_cs",
        "non_cs_override",
        "lead",
        "rma_lead",
        "rsa_lead",
        "developer",
        "admin",
      ];
      let current = roles.indexOf(
        get(this.current_user, "role", "").toLowerCase()
      );
      if (this.current_user.allow_role_change) {
        return roles.slice(0, current);
      } else {
        return roles.slice(current, current + 1);
      }
    },
    hasNewLeftNavEnabled() {
      return this.$store.getters["auth/isNewLeftNav"];
    },
  },
  created() {
    this.loadUser().then(
      (this.current_user = cloneDeep(this.user)),
      (this.current_user.role = this.current_user.role.toLowerCase())
    );
  },
  methods: {
    ...uiActions(["setLoading"]),
    ...authActions(["logOut"]),
    ...authActions(["updateAdminUser", "loadAdminUser"]),

    goBack() {
      this.$router.go(-1);
    },
    loadUser() {
      return this.loadAdminUser();
    },
    updateUser() {
      let payload = {
        role: this.current_user.role,
        timezone: this.current_user.timezone,
        first_name: this.current_user.first_name,
        last_name: this.current_user.last_name,
      };
      this.updateAdminUser(payload)
        .then(() => {
          this.$message({
            message: "Congratulations, your profile has been updated",
            type: "success",
          });
        })
        .catch(() => {
          this.$message({
            message: "Unable to update your profile",
            type: "error",
          });
        });
    },
    takeMeOut() {
      this.$confirm("This will log you out. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.setLoading(true);
          this.logOut()
            .then(() => {
              this.$router.push({ path: "/login" });
              this.setLoading(false);
            })
            .catch((error) => {
              console.error("Could not logout");
            })
            .finally(() => {
              this.setLoading(false);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
  },
};
</script>

<style lang="scss">
.profile-page {
  padding: 20px;
  background: #fff;
  margin: 40px 0px 0px;
  h2 {
    text-align: center;
    border-bottom: solid 1px #eee;
    padding-bottom: 20px;
    color: #1998d5;
  }
}
.profile-row {
  margin: 40px 0px;
  input {
    padding: 10px;
    height: 2.5em;
    font-size: 20px;
  }
  .profile-label {
    font-size: 25px;
    float: left;
    margin: 15px 0px;
  }
}
</style>
